// Official Mastro logo (do not restyle). Rendered as-is from /public.
export const MastroBrand = ({ className = "h-9", testId = "brand-logo" }) => (
  <img
    src="/mastro-logo.png"
    alt="Mastro"
    data-testid={testId}
    className={`${className} w-auto select-none`}
    draggable={false}
  />
);
